package de.ohhhmhhh.backend.sdk.revocations

import de.ohhhmhhh.backend.models.model.revocation.RevocationEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationFilterEntity
import de.ohhhmhhh.backend.models.model.shared.PageRequestEntity
import de.ohhhmhhh.backend.models.model.shared.PageResultEntity
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*

class RevocationServiceImpl(private val client: HttpClient) : RevocationService {
    override suspend fun getAll(request: PageRequestEntity<RevocationFilterEntity>): PageResultEntity<RevocationEntity> {
        return client.post("/revocations") {
            setBody(request)
        }.body()
    }

    override suspend fun update(revocation: RevocationEntity): RevocationEntity {
        return client.put("/revocations/${revocation.id}") {
            setBody(revocation)
        }.body()
    }
}